import api from './api';

export type CheckinContext = {
  tokenValid: boolean;
  visitDateKey: string;
  expiresAt: string;
  agency?: { id: string; name?: string; slug?: string };
  property?: {
    id: string;
    address?: {
      street?: string;
      city?: string;
      state?: string;
      country?: string;
      postalCode?: string;
      formattedAddress?: string;
    };
    status?: string;
    primaryAssignee?: string;
  };
};

export type SubmitCheckinRequest = {
  firstName: string;
  lastName: string;
  phone: string;
  email?: string;
  notes?: string;
  consentMarketing?: boolean;
  consentContact?: boolean;
};

export type SubmitCheckinResponse = {
  checkInId: string;
  attendeeId: string;
  visitDateKey: string;
  status: string;
  alreadyCheckedIn: boolean;
};

export const fetchCheckinContext = async (token: string): Promise<CheckinContext> => {
  const response = await api.get<CheckinContext>(`/checkin?t=${encodeURIComponent(token)}`);
  return response.data;
};

export const submitCheckin = async (
  token: string,
  payload: SubmitCheckinRequest
): Promise<SubmitCheckinResponse> => {
  const response = await api.post<SubmitCheckinResponse>(`/checkin?t=${encodeURIComponent(token)}`, payload);
  return response.data;
};
